<template>
  <section>
    <v-dialog
      v-model="modalAction"
      max-width="1200px"
      scrollable
      @keydown="executeCloseModalMaterialsRequest"
      @click:outside="executeCloseModalMaterialsRequest"
    >
      <v-card v-if="currentRequest">
        <div class="p-4 pb-0">
          <h5>
            Código SAP Solicitud: <b>{{ currentRequest.sap_code }}</b> -
            Proyecto/CECO:
            <b>
              {{
                currentRequest.project
                  ? currentRequest.project.code
                  : currentReques.cost_center.sap_code
              }}
            </b>
          </h5>
        </div>
        <hr />
        <v-card-text>
          <v-container class="pt-0">
            <div class="d-flex justify-content-end">
              <section class="w-25">
                <v-text-field
                  v-model="filters.filter"
                  class="px-2"
                  clearable
                  placeholder="Buscar:"
                ></v-text-field>
              </section>
            </div>
            <v-data-table
              class="px-2 elevation-4 pt-2"
              :headers="tableHeaders"
              :items="filteredMaterials"
              :items-per-page="200"
              hide-default-footer
              loading-text="Cargando materiales"
              item-key="id"
              no-data-text="Sin materiales"
              @page-count="pageCount = $event"
            >
              <template v-slot:item.code="{ item }">
                <div class="d-flex justify-content-start">
                  <v-chip label small color="primary" class="mt-0 text-white">
                    {{ item.code }}
                  </v-chip>
                </div>
              </template>
              <template v-slot:item.name="{ item }">
                <p class="text-left my-0" style="font-size: 11px">
                  {{ item.name }}
                </p>
              </template>
              <template v-slot:item.unit="{ item }">
                <p class="text-center my-0" style="font-size: 11px">
                  {{ item.unit }}
                </p>
              </template>
              <template v-slot:item.sap_code="{ item }">
                <p class="text-left my-0" style="font-size: 11px">
                  {{ item.sap_code }}
                </p>
              </template>
              <template v-slot:item.quantity="{ item }">
                <p class="text-right mt-4" style="font-size: 11px">
                  {{ item.quantity }}
                </p>
              </template>
            </v-data-table>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="red darken-1"
            outlined
            @click="executeCloseModalMaterialsRequest"
          >
            <small>
              Cerrar
            </small>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </section>
</template>

<script>
import { authUsuarioComputed } from "@/state/helpers";
import { preventCloseIfNotKeyEventEsc } from "@/helpers/common";
export default {
  props: {
    modalAction: {
      type: Boolean,
      default: false,
    },
    closeModalMaterialsRequest: {
      type: Function,
      default: () => {},
    },
    currentRequest: {
      default: null,
    },
  },
  data() {
    return {
      currentMaterials: [],
      filters: {
        filter: "",
      },
      tableHeaders: [
        {
          text: "Código Material",
          align: "start",
          sortable: false,
          value: "sap_code",
        },
        {
          text: "Descripción",
          class: "text-left",
          sortable: false,
          value: "name",
        },
        {
          text: "Cantidad",
          align: "center",
          sortable: false,
          width: "10%",
          value: "quantity",
        },
        {
          text: "Unidad",
          align: "center",
          sortable: false,
          value: "unit",
        },
      ],
    };
  },
  methods: {
    executeCloseModalMaterialsRequest($event) {
      let validationEvent = preventCloseIfNotKeyEventEsc($event);
      if (validationEvent) {
        this.currentMaterials = [];
        this.closeModalMaterialsRequest($event);
      }
    },
    setMaterialsCurrentRequest(request) {
      this.currentMaterials.push(
        ...request.items.map((item) => {
          return {
            ...item.material,
            quantity: item.quantity,
            unit: item.material.measurement_unit,
            sap_code: item.material.code,
          };
        })
      );
    },
  },
  computed: {
    ...authUsuarioComputed,
    filteredMaterials() {
      if (this.filters.filter) {
        let filter = this.filters.filter.trim().toLowerCase();
        return this.currentMaterials.filter((request) => {
          return (
            request.sap_code.toLowerCase().includes(filter) ||
            request.name.toLowerCase().includes(filter) ||
            request.unit.toLowerCase().includes(filter)
          );
        });
      }
      return this.currentMaterials;
    },
  },
  watch: {
    currentRequest(newRequest) {
      if (newRequest) {
        this.setMaterialsCurrentRequest(newRequest);
      }
    },
  },
};
</script>

<style></style>
